import { render } from "./resultNotificationPage.vue?vue&type=template&id=20eef3bc&ts=true"
import script from "./resultNotificationPage.vue?vue&type=script&lang=ts"
export * from "./resultNotificationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__